import React from 'react';
import { Modal} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoneyCheck } from '@fortawesome/free-solid-svg-icons';
import AccountList from "./AccountList";

const AccountManageModal = (props) => {
    const {show, onClose, accountList, onAdd, onChange, onDelete} = props;
    return (
        <Modal show={show} backdrop="static">
            <Modal.Header>
                <Modal.Title className="text-scb"><FontAwesomeIcon icon={faMoneyCheck} className="mr-2"/>Bank Account Number</Modal.Title>
            </Modal.Header>
            <Modal.Body className="modal-fixed-height p-5">
                <AccountList
                    accountList={accountList}
                    onClose = {onClose}
                />
            </Modal.Body>
        </Modal>
    );
}
export default AccountManageModal;